import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import SubNav from './Common/SubNav';
import Footer from './Common/Footer';
import RadioButtons from './Common/RadioButtons';
import { alertAction } from '../Redux/Actions/alertAction';

const AddInvoice = ({ isShow, setIsShow }) => {
    const [isCheque, setIsCheque] = useState(false);
    const { slug } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const initialValues = { selectMember: '', pkgMaster: '', mobile: '', amount: '', receivedBy: '', bank: '', checkNo: '', issueDate: '', remarks: '', nextPayDate: '', receiver: '' };
    const [formErrors, setFormErrors] = useState({});
    const [formValues, setFormValues] = useState(initialValues);
    const [isSubmit, setIsSubmit] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        getInputValue(value, setFormValues, formValues, name);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validate(formValues));
        setIsSubmit(true);
        console.log(formValues);
    };

    useEffect(() => {
        if (Object.keys(formErrors).length === 0 && isSubmit) {
            navigate('/admin/receipt/all');
            dispatch(alertAction());
            setIsSubmit(false);
        }
    }, [formErrors, isSubmit]);

    const validate = (values) => {
        const errors = {};
        return validation(values, errors, isCheque);
    };

    useEffect(() => {
        if (slug) {
            setFormValues({ selectMember: 'Hemant', pkgMaster: 'Weight Loss', mobile: '9856745345', amount: '3000', receivedBy: 'Rajiv', bank: 'mankamana bikash bank', checkNo: '100234657', issueDate: '2022-02-12', remarks: '', nextPayDate: '', receiver: 'Hemant' })
        }
    }, [slug])


    return (
        <div className='page_first_div'>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='page_sec_div '>
                <p className='page_topic inline-block'>{`${slug ? "Edit" : "Add"} Invoice`}</p>
                <div className='inline-block bg-cyan-600 px-3 py-1 ml-2 rounded-md hover:bg-cyan-700 animation'>
                    <Link to="/admin/receipt/all" className='link block text-white text-sm'>
                        <i className="fa-solid fa-arrow-left mr-1"></i>
                        All
                    </Link>
                </div>
                <section className='page_section px-4 xsm:px-8 py-2 min-h-[25rem]'>

                    <form action="" onSubmit={handleSubmit}>
                        {/* Member and Receivers */}
                        <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-10'>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Select Member Name<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='selectMember' value={formValues.selectMember} onChange={handleChange}>
                                    <option value=''>--Select Member Name--</option>
                                    <option value="Maria">Maria</option>
                                    <option value="Hemant">Hemant</option>
                                    <option value="Rajiv">Rajiv</option>
                                    <option value="Sharan">Sharan</option>
                                </select>
                                <small className="text-red-500 tracking-wide">{formErrors.selectMember}</small>
                            </div>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Package Master<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='pkgMaster' value={formValues.pkgMaster} onChange={handleChange}>
                                    <option value=''>--Select Program--</option>
                                    <option value="Weight Loss" className=''>Weight Loss</option>
                                    <option value="Weight Gain">Weight Gain</option>
                                </select>
                                <small className="text-red-500 tracking-wide">{formErrors.pkgMaster}</small>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Receiver Name<span className='text-red-500'>&#42;</span>
                                </p>
                                <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Member Name' name='receiver' value={formValues.receiver} onChange={handleChange} disabled />
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Mobile Number<span className='text-red-500'>&#42;</span></p>
                                <div className='form_div'>
                                    <input type="number" className='form_input_icon' placeholder='Please Provide Mobile No.' name='mobile' value={formValues.mobile} onChange={handleChange} />
                                    <p className='form_icon_para'>
                                        <i className="fa-solid fa-mobile-screen-button"></i>
                                    </p>
                                </div>
                                <small className="text-red-500 tracking-wide">{formErrors.mobile}</small>
                            </div>
                        </div>
                        <h3 className='text-gray-800 underline text-lg mt-4'>Payment Details</h3>

                        {/* Payment Details */}
                        <div className='grid gap-4 lg:grid-cols-2 lg:gap-6 pt-2'>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider'>Payment Amount<span className='text-red-500'>&#42;</span></p>
                                <div className='flex justify-center items-baseline h-10 w-full border-2 text-gray-700 outline-gray-300 rounded'>
                                    <p className='h-full text-center flex-1 px-1 sm:px-0'>Rs.</p>
                                    <input type="number" className='placeholder:text-sm placeholder:text-gray-700 flex-[9] outline-none h-full pr-6 border-l-2 pl-2 text-sm' name='amount' value={formValues.amount} onChange={handleChange} />
                                </div>
                                <small className="text-red-500 tracking-wide">{formErrors.amount}</small>
                            </div>
                            <div className='font-lato '>
                                <p className='text-gray-800 font-semibold tracking-wider text-sm xsm:text-base'>Received By<span className='text-red-500'>&#42;</span></p>
                                <select className="selector" name='receivedBy' value={formValues.receivedBy} onChange={handleChange}>
                                    <option value=''>--Select Receiver--</option>
                                    <option value="Maria">Maria</option>
                                    <option value="Hemant">Hemant</option>
                                    <option value="Rajiv">Rajiv</option>
                                    <option value="Sharan">Sharan</option>
                                </select>
                                <small className="text-red-500 tracking-wide">{formErrors.receivedBy}</small>
                            </div>
                            <div className='font-lato'>
                                <RadioButtons setIsCheque={setIsCheque} />
                            </div>

                            {/* conditional redering for payment modes */}
                            {isCheque && <>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider'>Check No<span className='text-red-500'>&#42;</span>
                                    </p>
                                    <input type="number" className='form_input border-2 pr-6 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Cheque Number' name='checkNo' value={formValues.checkNo} onChange={handleChange} />
                                    <small className="text-red-500 tracking-wide">{formErrors.checkNo}</small>
                                </div>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider '>Bank Name<span className='text-red-500'>&#42;</span>
                                    </p>
                                    <input type="text" className='form_input border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' placeholder='Please Provide Bank Name' name='bank' value={formValues.bank} onChange={handleChange} />
                                    <small className="text-red-500 tracking-wide">{formErrors.bank}</small>
                                </div>
                                <div className='font-lato text-sm xsm:text-base '>
                                    <p className='text-gray-800 font-semibold tracking-wider '>Issued Date<span className='text-red-500'>&#42;</span>
                                    </p>
                                    <input type="date" className='form_input_date border-2 h-10 w-full placeholder:text-xs xsm:placeholder:text-sm' name='issueDate' value={formValues.issueDate} onChange={handleChange} />
                                    <small className="text-red-500 tracking-wide">{formErrors.issueDate}</small>
                                </div>
                            </>}

                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Remarks</p>
                                <textarea className='pl-4 pt-2 text-gray-800 text-sm h-12 rounded w-full outline-none border-2 placeholder:text-xs xsm:placeholder:text-sm' placeholder='Remarks...' name='remarks' value={formValues.remarks} onChange={handleChange} ></textarea>
                            </div>
                            <div className='font-lato text-sm xsm:text-base '>
                                <p className='text-gray-800 font-semibold tracking-wider '>Next Payment Date
                                </p>
                                <input type="date" className='form_input_date border-2 h-10 w-full' name='nextPayDate' value={formValues.nextPayDate} onChange={handleChange} />
                            </div>
                        </div>

                        {/* Save Reset */}
                        <div className='pt-4 lg:pt-10'>
                            <button className='button mr-2' type='submit'>{`${slug ? "Update" : "Save"}`}</button>
                            <button className='button2' type='reset' onClick={() => setFormValues(initialValues)}>Reset</button>
                        </div>
                    </form>
                </section>
            </div>
            <Footer />
        </div>
    )
}

export default AddInvoice;

function getInputValue(value, setFormValues, formValues, name) {
    if (value === 'Hemant') {
        setFormValues({ ...formValues, receiver: value, mobile: '9845634123', [name]: value });
    }
    else if (value === 'Maria') {
        setFormValues({ ...formValues, receiver: value, mobile: '9848669123', [name]: value });
    }
    else if (value === 'Rajiv') {
        setFormValues({ ...formValues, receiver: value, mobile: '9848669123', [name]: value });
    }
    else if (value === 'Sharan') {
        setFormValues({ ...formValues, receiver: value, mobile: '9848669123', [name]: value });
    }
    else if (value === 'Weight Loss') {
        setFormValues({ ...formValues, amount: 3000, [name]: value });
    }
    else if (value === 'Weight Gain') {
        setFormValues({ ...formValues, amount: 2500, [name]: value });
    }
    else {
        setFormValues({ ...formValues, [name]: value });
    }
}

function validation(values, errors, isCheque) {
    if (values.selectMember === '') {
        errors.selectMember = "Member name must be selected!";
    }
    if (values.pkgMaster === '') {
        errors.pkgMaster = "Program must be selected!";
    }
    if (values.receivedBy === '') {
        errors.receivedBy = "Received by must be selected!";
    }
    if (!values.mobile) {
        errors.mobile = "This field is mandatory!";
    }
    else if (values.mobile.length < 10) {
        errors.mobile = "Not a valid number!";
    }
    else if (values.mobile.length > 10) {
        errors.mobile = "Not a valid number!";
    }
    if (!values.amount) {
        errors.amount = "This field is mandatory!";
    }
    if (!values.checkNo && isCheque) {
        errors.checkNo = "This field is mandatory!";
    }
    if (!values.bank && isCheque) {
        errors.bank = "This field is mandatory!";
    }
    if (!values.issueDate && isCheque) {
        errors.issueDate = "This field is mandatory!";
    }
    return errors;
}
